import { styled } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { useI18n } from '@app-velocity/i18n';
import { Form, TextField } from '@app-velocity/ui';

import { PersonaFormValues } from '../../../../types/persona';

const StyledSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const PersonaTraitsSection = () => {
  const { t } = useI18n();
  const { control } = useFormContext<PersonaFormValues>();

  return (
    <StyledSection>
      <Form.FieldContainer>
        <Form.Label>{t('personas:form.strengths')}</Form.Label>
        <TextField
          name="strengths"
          control={control}
          fullWidth
          multiline
          minRows={3}
          maxRows={8}
          placeholder={t('personas:form.strengths_placeholder')}
        />
      </Form.FieldContainer>
      <Form.FieldContainer>
        <Form.Label>{t('personas:form.weaknesses')}</Form.Label>
        <TextField
          name="weaknesses"
          control={control}
          fullWidth
          multiline
          minRows={3}
          maxRows={8}
          placeholder={t('personas:form.weaknesses_placeholder')}
        />
      </Form.FieldContainer>
    </StyledSection>
  );
};
